import { ContentNode } from '@amzn/awscat-pattern-library-service-model';
import React from 'react';
import { getText } from '@amzn/awscat-editor';
import { Box, Link, SpaceBetween } from '@amzn/awsui-components-core';
interface Props {
  contentSections: ContentNode[];
}

const ContentSectionsNavigation = (props: Props) => {
  const { contentSections } = props;
  return contentSections?.length ? (
    <div>
      <Box padding={{ left: 's' }}>
        <SpaceBetween size="xxs">
          {contentSections.map((section) => (
            <Box key={section.id}>
              <Link href={`#${section.href || section.id}`}>{getText(section.title)}</Link>
            </Box>
          ))}
        </SpaceBetween>
      </Box>
    </div>
  ) : null;
};

export default ContentSectionsNavigation;
